// @flow
import { QuestionTypesOpinometroActionTypes } from './constants';

type QuestionTypesOpinometroAction = { type: string, payload: {} | string };

// common success
export const questionTypesOpinometroApiResponseSuccess = (actionType: string, data: any): QuestionTypesOpinometroAction => ({
    type: QuestionTypesOpinometroActionTypes.API_RESPONSE_SUCCESS,
    payload: { actionType, data },
});
// common error
export const questionTypesOpinometroApiResponseError = (actionType: string, error: string): QuestionTypesOpinometroAction => ({
    type: QuestionTypesOpinometroActionTypes.API_RESPONSE_ERROR,
    payload: { actionType, error },
});

export const getQuestionTypeOpinometro = (id: string): QuestionTypesOpinometroAction => ({
    type: QuestionTypesOpinometroActionTypes.GET_QUESTION_TYPE_OPINOMETRO,
    payload: { id },
});

export const addQuestionTypeOpinometro = (questionType: any): QuestionTypesOpinometroAction => ({
    type: QuestionTypesOpinometroActionTypes.ADD_QUESTION_TYPE_OPINOMETRO,
    payload: questionType
})
export const updateQuestionTypeOpinometro = (questionType: any): QuestionTypesOpinometroAction => ({
    type: QuestionTypesOpinometroActionTypes.UPDATE_QUESTION_TYPE_OPINOMETRO,
    payload: questionType
})
export const deleteQuestionTypeOpinometro = (id: string): QuestionTypesOpinometroAction => ({
    type: QuestionTypesOpinometroActionTypes.DELETE_QUESTION_TYPE_OPINOMETRO,
    payload: { id }
})

export const listQuestionTypesOpinometro = (params: any): QuestionTypesOpinometroAction => ({
    type: QuestionTypesOpinometroActionTypes.LIST_QUESTION_TYPES_OPINOMETRO,
    payload: params,
});


export const resetQuestionTypesOpinometro = (): QuestionTypesOpinometroAction => ({
    type: QuestionTypesOpinometroActionTypes.RESET,
    payload: {},
});

